export const formatIotTypeLabel = (type: string): string =>
    type
        .split('_')
        .filter(Boolean)
        .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
        .join(' ');
